import { features, stats } from '@/mocks/home';

export default function QualityFeatures() {
  return (
    <section className="py-16 md:py-20 bg-background-100" aria-labelledby="features-heading">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <p className="text-xs font-label tracking-[0.15em] uppercase text-foreground-500 mb-3">为什么选择久久久</p>
          <h2 id="features-heading" className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            经得起时间检验的品质承诺
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-14 md:mb-16">
          {features.map((feat) => (
            <div key={feat.title} className="bg-background-50 rounded-xl p-6 md:p-7">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100/80 mb-4">
                <i className={`${feat.icon} text-xl text-accent-700`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70">
              <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-1">{stat.value}</p>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}